import XDatePicker from '@/Mantine/XDatePicker'
import XNumberInput from '@/Mantine/XNumberInput'
import XSelect from '@/Mantine/XSelect'
import { XTextarea } from '@/Mantine/XTextarea'
import XTextInput from '@/Mantine/XTextInput'
import { RootState } from '@/Store'
import { updateCurrentStep, updateLead } from '@/Store/leadFormSlice'
import { Button, Divider, HStack, TabItem, Tabs, VStack, XelaColor } from '@/XelaReact'
import { LoadingOverlay } from '@mantine/core'
import axios from 'axios'
import moment from 'moment'
import { FC, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

interface FormData {
  tenth_school_name: string
  tenth_year: number | ''
  tenth_board: string
  tenth_percentage: string
  tenth_medium_of_instruction: string
  tenth_result_date: string
  twelfth_school_name: string
  twelfth_year: number | ''
  twelfth_board: string
  twelfth_percentage: string
  twelfth_stream: string
  twelfth_medium_of_instruction: string
  twelfth_result_date: string
  twelfth_english_marks: string | ''
  bachelor_one_year: number | ''
  bachelor_one_college: string
  bachelor_one_course: string
  bachelor_one_percentage: string
  bachelor_one_reappears: number | ''
  bachelor_one_duration: string
  bachelor_one_result_date: string
  bachelor_one_medium_of_instruction: string
  bachelor_two_year: number | ''
  bachelor_two_college: string
  bachelor_two_course: string
  bachelor_two_percentage: string
  bachelor_two_reappears: number | ''
  bachelor_two_duration: string
  bachelor_two_result_date: string
  bachelor_two_medium_of_instruction: string
  master_one_year: number | ''
  master_one_college: string
  master_one_course: string
  master_one_percentage: string
  master_one_reappears: number | ''
  master_one_duration: string
  master_one_result_date: string
  master_one_medium_of_instruction: string
  master_two_year: number | ''
  master_two_college: string
  master_two_course: string
  master_two_percentage: string
  master_two_reappears: number | ''
  master_two_duration: string
  master_two_result_date: string
  master_two_medium_of_instruction: string
  diploma_one_year: number | ''
  diploma_one_college: string
  diploma_one_course: string
  diploma_one_percentage: string
  diploma_one_reappears: number | ''
  diploma_one_duration: string
  diploma_one_level: string
  diploma_one_result_date: string
  diploma_one_medium_of_instruction: string
  diploma_two_year: number | ''
  diploma_two_college: string
  diploma_two_course: string
  diploma_two_percentage: string
  diploma_two_reappears: number | ''
  diploma_two_duration: string
  diploma_two_level: string
  diploma_two_result_date: string
  diploma_two_medium_of_instruction: string
  other_educations: string
}

const LeadFormEducationDetail: FC<{ fields: string[]; requirements: string[]; agencyId: number }> = ({
  fields,
  requirements,
  agencyId,
}) => {
  const tabItems: TabItem[] = []
  const [errors, setErrors] = useState<{ [key: string]: string }>({})

  if (fields.includes('tenth_details')) {
    tabItems.push({ label: 'Tenth(SSC)', value: 'Tenth' })
  }
  if (fields.includes('twelfth_details')) {
    tabItems.push({ label: 'Twelfth(HSC)', value: 'Twelfth' })
  }
  if (fields.includes('bachelor_details')) {
    tabItems.push({ label: 'Bachelors', value: 'Bachelors' })
  }
  if (fields.includes('master_details')) {
    tabItems.push({ label: 'Masters', value: 'Masters' })
  }
  if (fields.includes('diploma_details')) {
    tabItems.push({ label: 'Diplomas', value: 'Diplomas' })
  }

  if (fields.includes('other_educations')) {
    tabItems.push({ label: 'Others', value: 'Others' })
  }

  const educationalTab: string = fields.includes('tenth_details')
    ? 'Tenth'
    : fields.includes('twelfth_details')
    ? 'Twelfth'
    : fields.includes('bachelor_details')
    ? 'Bachelors'
    : fields.includes('master_details')
    ? 'Masters'
    : fields.includes('diploma_details')
    ? 'Diplomas'
    : 'Others'
  const dispatch = useDispatch()
  const leadStore = useSelector((state: RootState) => state.leadForm)
  const [tab, setTab] = useState(educationalTab)
  const [loading, setLoading] = useState(false)
  const [formData, setFormData] = useState<FormData>({
    tenth_school_name: '',
    tenth_year: '',
    tenth_board: '',
    tenth_percentage: '',
    tenth_medium_of_instruction: '',
    tenth_result_date: '',
    twelfth_school_name: '',
    twelfth_year: '',
    twelfth_board: '',
    twelfth_percentage: '',
    twelfth_stream: '',
    twelfth_english_marks: '',
    twelfth_medium_of_instruction: '',
    twelfth_result_date: '',
    bachelor_one_year: '',
    bachelor_one_college: '',
    bachelor_one_course: '',
    bachelor_one_percentage: '',
    bachelor_one_reappears: 0,
    bachelor_one_duration: '',
    bachelor_one_result_date: '',
    bachelor_one_medium_of_instruction: '',
    bachelor_two_year: '',
    bachelor_two_college: '',
    bachelor_two_course: '',
    bachelor_two_percentage: '',
    bachelor_two_reappears: 0,
    bachelor_two_duration: '',
    bachelor_two_result_date: '',
    bachelor_two_medium_of_instruction: '',
    master_one_year: '',
    master_one_college: '',
    master_one_course: '',
    master_one_percentage: '',
    master_one_reappears: 0,
    master_one_duration: '',
    master_one_result_date: '',
    master_one_medium_of_instruction: '',
    master_two_year: '',
    master_two_college: '',
    master_two_course: '',
    master_two_percentage: '',
    master_two_reappears: 0,
    master_two_duration: '',
    master_two_result_date: '',
    master_two_medium_of_instruction: '',
    diploma_one_year: '',
    diploma_one_college: '',
    diploma_one_course: '',
    diploma_one_percentage: '',
    diploma_one_reappears: 0,
    diploma_one_duration: '',
    diploma_one_level: '',
    diploma_one_result_date: '',
    diploma_one_medium_of_instruction: '',
    diploma_two_year: '',
    diploma_two_college: '',
    diploma_two_course: '',
    diploma_two_percentage: '',
    diploma_two_reappears: 0,
    diploma_two_duration: '',
    diploma_two_level: '',
    diploma_two_result_date: '',
    diploma_two_medium_of_instruction: '',
    other_educations: '',
  })

  useEffect(() => {
    if (leadStore.lead) {
      const lead = leadStore.lead
      setFormData({
        tenth_school_name: lead.tenth_details?.tenth_school_name || '',
        tenth_year: lead.tenth_details?.tenth_year || '',
        tenth_board: lead.tenth_details?.tenth_board || '',
        tenth_percentage: lead.tenth_details?.tenth_percentage || '',
        tenth_medium_of_instruction: lead.tenth_details?.tenth_medium_of_instruction || '',
        tenth_result_date: lead.tenth_details?.tenth_result_date || '',
        twelfth_school_name: lead.twelfth_details?.twelfth_school_name || '',
        twelfth_year: lead.twelfth_details?.twelfth_year || '',
        twelfth_board: lead.twelfth_details?.twelfth_board || '',
        twelfth_percentage: lead.twelfth_details?.twelfth_percentage || '',
        twelfth_stream: lead.twelfth_details?.twelfth_stream || '',
        twelfth_english_marks: lead.twelfth_details?.twelfth_english_marks || '',
        twelfth_medium_of_instruction: lead.twelfth_details?.twelfth_medium_of_instruction || '',
        twelfth_result_date: lead.twelfth_details?.twelfth_result_date || '',
        bachelor_one_year: lead.bachelors ? lead.bachelors[0]?.bachelor_year || '' : '',
        bachelor_one_college: lead.bachelors ? lead.bachelors[0]?.bachelor_college || '' : '',
        bachelor_one_course: lead.bachelors ? lead.bachelors[0]?.bachelor_course || '' : '',
        bachelor_one_percentage: lead.bachelors ? lead.bachelors[0]?.bachelor_percentage || '' : '',
        bachelor_one_reappears: lead.bachelors ? lead.bachelors[0]?.bachelor_reappears || 0 : 0,
        bachelor_one_medium_of_instruction: lead.bachelors
          ? lead.bachelors[0]?.bachelor_medium_of_instruction || ''
          : '',
        bachelor_one_result_date: lead.bachelors ? lead.bachelors[0]?.bachelor_result_date || '' : '',
        bachelor_one_duration: lead.bachelors ? lead.bachelors[0]?.bachelor_duration || '' : '',
        bachelor_two_year: lead.bachelors ? lead.bachelors[1]?.bachelor_year || '' : '',
        bachelor_two_college: lead.bachelors ? lead.bachelors[1]?.bachelor_college || '' : '',
        bachelor_two_course: lead.bachelors ? lead.bachelors[1]?.bachelor_course || '' : '',
        bachelor_two_percentage: lead.bachelors ? lead.bachelors[1]?.bachelor_percentage || '' : '',
        bachelor_two_reappears: lead.bachelors ? lead.bachelors[1]?.bachelor_reappears || 0 : 0,
        bachelor_two_medium_of_instruction: lead.bachelors
          ? lead.bachelors[1]?.bachelor_medium_of_instruction || ''
          : '',
        bachelor_two_result_date: lead.bachelors ? lead.bachelors[1]?.bachelor_result_date || '' : '',
        bachelor_two_duration: lead.bachelors ? lead.bachelors[1]?.bachelor_duration || '' : '',
        master_one_year: lead.masters ? lead.masters[0]?.master_year || '' : '',
        master_one_college: lead.masters ? lead.masters[0]?.master_college || '' : '',
        master_one_course: lead.masters ? lead.masters[0]?.master_course || '' : '',
        master_one_percentage: lead.masters ? lead.masters[0]?.master_percentage || '' : '',
        master_one_reappears: lead.masters ? lead.masters[0]?.master_reappears || 0 : 0,
        master_one_medium_of_instruction: lead.masters ? lead.masters[0]?.master_medium_of_instruction || '' : '',
        master_one_result_date: lead.masters ? lead.masters[0]?.master_result_date || '' : '',
        master_one_duration: lead.masters ? lead.masters[0]?.master_duration || '' : '',
        master_two_year: lead.masters ? lead.masters[1]?.master_year || '' : '',
        master_two_college: lead.masters ? lead.masters[1]?.master_college || '' : '',
        master_two_course: lead.masters ? lead.masters[1]?.master_course || '' : '',
        master_two_percentage: lead.masters ? lead.masters[1]?.master_percentage || '' : '',
        master_two_reappears: lead.masters ? lead.masters[1]?.master_reappears || 0 : 0,
        master_two_medium_of_instruction: lead.masters ? lead.masters[1]?.master_medium_of_instruction || '' : '',
        master_two_result_date: lead.masters ? lead.masters[1]?.master_result_date || '' : '',
        master_two_duration: lead.masters ? lead.masters[1]?.master_duration || '' : '',
        diploma_one_year: lead.diplomas ? lead.diplomas[0]?.diploma_year || '' : '',
        diploma_one_college: lead.diplomas ? lead.diplomas[0]?.diploma_college || '' : '',
        diploma_one_course: lead.diplomas ? lead.diplomas[0]?.diploma_course || '' : '',
        diploma_one_percentage: lead.diplomas ? lead.diplomas[0]?.diploma_percentage || '' : '',
        diploma_one_reappears: lead.diplomas ? lead.diplomas[0]?.diploma_reappears || 0 : 0,
        diploma_one_medium_of_instruction: lead.diplomas ? lead.diplomas[0]?.diploma_medium_of_instruction || '' : '',
        diploma_one_result_date: lead.diplomas ? lead.diplomas[0]?.diploma_result_date || '' : '',
        diploma_one_duration: lead.diplomas ? lead.diplomas[0]?.diploma_duration || '' : '',
        diploma_one_level: lead.diplomas ? lead.diplomas[0]?.diploma_level || '' : '',
        diploma_two_year: lead.diplomas ? lead.diplomas[1]?.diploma_year || '' : '',
        diploma_two_college: lead.diplomas ? lead.diplomas[1]?.diploma_college || '' : '',
        diploma_two_course: lead.diplomas ? lead.diplomas[1]?.diploma_course || '' : '',
        diploma_two_percentage: lead.diplomas ? lead.diplomas[1]?.diploma_percentage || '' : '',
        diploma_two_reappears: lead.diplomas ? lead.diplomas[1]?.diploma_reappears || 0 : 0,
        diploma_two_medium_of_instruction: lead.diplomas ? lead.diplomas[1]?.diploma_medium_of_instruction || '' : '',
        diploma_two_result_date: lead.diplomas ? lead.diplomas[1]?.diploma_result_date || '' : '',
        diploma_two_duration: lead.diplomas ? lead.diplomas[1]?.diploma_duration || '' : '',
        diploma_two_level: lead.diplomas ? lead.diplomas[1]?.diploma_level || '' : '',
        other_educations: lead.other_educations || '',
      })
    }
  }, [leadStore.lead])

  useEffect(() => {
    const prioritizeTab = () => {
      const errorKeys = Object.keys(errors)
      if (errorKeys.length > 0) {
        if (fields.includes('tenth_details') && (errors.tenth_year || errors.tenth_board || errors.tenth_percentage)) {
          setTab('Tenth')
        } else if (
          fields.includes('twelfth_details') &&
          (errors.twelfth_year || errors.twelfth_board || errors.twelfth_percentage || errors.twelfth_stream)
        ) {
          setTab('Twelfth')
        } else if (
          fields.includes('bachelor_details') &&
          (errors.bachelor_one_year ||
            errors.bachelor_one_college ||
            errors.bachelor_one_course ||
            errors.bachelor_one_percentage ||
            errors.bachelor_one_reappears ||
            errors.bachelor_two_year ||
            errors.bachelor_two_college ||
            errors.bachelor_two_course ||
            errors.bachelor_two_percentage ||
            errors.bachelor_two_reappears)
        ) {
          setTab('Bachelors')
        } else if (
          fields.includes('master_details') &&
          (errors.master_one_year ||
            errors.master_one_college ||
            errors.master_one_course ||
            errors.master_one_percentage ||
            errors.master_one_reappears ||
            errors.master_two_year ||
            errors.master_two_college ||
            errors.master_two_course ||
            errors.master_two_percentage ||
            errors.master_two_reappears)
        ) {
          setTab('Masters')
        } else if (
          fields.includes('diploma_details') &&
          (errors.diploma_one_year ||
            errors.diploma_one_college ||
            errors.diploma_one_course ||
            errors.diploma_one_percentage ||
            errors.diploma_one_reappears ||
            errors.diploma_two_year ||
            errors.diploma_two_college ||
            errors.diploma_two_course ||
            errors.diploma_two_percentage ||
            errors.diploma_two_reappears)
        ) {
          setTab('Diplomas')
        } else if (fields.includes('other_educations') && errors.other_educations) {
          setTab('Others')
        }
      } else {
        setTab(educationalTab)
      }
    }

    prioritizeTab()
  }, [errors])

  const handleSubmit = async () => {
    if (leadStore.lead_id) {
      setLoading(true)
      try {
        const response = await axios.post(`/leads/form/${leadStore.lead_id}/education-details`, {
          ...formData,
          uuid: leadStore.lead_form_uuid,
          csrfToken: leadStore.csrfToken,
        })

        const { action, payload } = response.data

        if (action === 'education_details:update') {
          if (payload.lead) {
            setTab(educationalTab)
            dispatch(updateLead(payload.lead))
            dispatch(updateCurrentStep(leadStore.current_step + 1))
          }
        }
      } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
          setErrors(error.response.data.errors || {})
        }
      } finally {
        setLoading(false)
      }
    }
  }

  return (
    <>
      {leadStore.is_mobile_view && (
        <div style={{ position: 'fixed', left: 0, bottom: 0, width: '100vw', zIndex: 9999 }}>
          <HStack justifyContent="flex-end">
            <Button
              style={{
                borderRadius: 0,
                width: '100%',
                border: '1px solid #8E8C94 !important',
                background: '#FFFFFF',
                outline: 'none !important',
              }}
              label={'Back'}
              variant="secondary"
              onClick={() => {
                dispatch(updateCurrentStep(leadStore.current_step - 1))
              }}
            ></Button>
            <Button
              style={{
                borderRadius: 0,
                width: '100%',
                border: '1px solid #003CFF !important',
                outline: 'none !important',
              }}
              label={leadStore.current_step === leadStore.total_step - 1 ? 'Save' : 'Save & Next'}
              onClick={handleSubmit}
            ></Button>
          </HStack>
        </div>
      )}
      <div
        style={{
          position: 'relative',
          width: '100%',
          height: '100%',
        }}
      >
        <LoadingOverlay visible={loading} overlayBlur={2} loaderProps={{ color: 'blueX' }} />
        <VStack spacing="12px" height="100%">
          <Tabs
            style={{
              width: '100%',
              borderBottomWidth: '2px',
              borderBottomStyle: 'solid',
              borderBottomColor: XelaColor.Gray12,
              borderRadius: '0px',
              flexWrap: leadStore.is_mobile_view ? 'wrap' : 'nowrap',
            }}
            items={tabItems}
            name="educational_details_edit_modal_tabs"
            defaultValue={tab}
            onChangeHandle={(value) => {
              setTab(value)
            }}
          ></Tabs>
          {tab === 'Tenth' && fields.includes('tenth_details') && (
            <VStack
              spacing="12px"
              style={{
                flex: '1 1 auto',
                paddingRight: '10px',
                height: leadStore.is_mobile_view ? 'auto' : '0',
                marginBottom: leadStore.is_mobile_view ? '50px' : '0px',
                overflowY: 'auto',
              }}
            >
              <HStack spacing="12px" style={{ flexWrap: 'wrap' }} alignItems="flex-start">
                <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                  <XNumberInput
                    required={requirements.includes('tenth_details')}
                    data-autofocus
                    type={'number'}
                    label={'Tenth Year'}
                    error={errors.tenth_year}
                    defaultValue={formData.tenth_year}
                    onChange={(value) => {
                      setFormData((prevData) => ({
                        ...prevData,
                        tenth_year: value,
                      }))
                    }}
                  />
                </HStack>
                <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                  <XSelect
                    required={requirements.includes('tenth_details')}
                    searchable
                    label={'Tenth Board'}
                    error={errors.tenth_board}
                    value={formData.tenth_board}
                    onInit={(callback) => {
                      axios
                        .post('/guest/select/lead-meta-options', {
                          entity_name: 'leads',
                          column_name: 'education_boards',
                          agency_id: agencyId,
                        })
                        .then((response) => {
                          callback(response.data)
                        })
                        .catch((error) => {
                          console.log(error)
                          callback([])
                        })
                    }}
                    onChange={(value) => {
                      if (value) {
                        setFormData((prevData) => ({
                          ...prevData,
                          tenth_board: value,
                        }))
                      }
                    }}
                  />
                </HStack>
                <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                  <XTextInput
                    required={requirements.includes('tenth_details')}
                    label={'Tenth Percentage/CGPA'}
                    error={errors.tenth_percentage}
                    value={formData.tenth_percentage}
                    onChange={(e) => {
                      setFormData((prevData) => ({
                        ...prevData,
                        tenth_percentage: e.target.value,
                      }))
                    }}
                  />
                </HStack>
                <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                  <XTextInput
                    required={requirements.includes('tenth_details')}
                    data-autofocus
                    label={'Tenth School Name'}
                    error={errors.tenth_school_name}
                    defaultValue={formData.tenth_school_name}
                    onChange={(e) => {
                      setFormData((prevData) => ({
                        ...prevData,
                        tenth_school_name: e.target.value,
                      }))
                    }}
                  />
                </HStack>
                <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                  <XTextInput
                    required={requirements.includes('tenth_details')}
                    data-autofocus
                    label={'Tenth Medium of Instruction'}
                    error={errors.tenth_medium_of_instruction}
                    defaultValue={formData.tenth_medium_of_instruction}
                    onChange={(e) => {
                      setFormData((prevData) => ({
                        ...prevData,
                        tenth_medium_of_instruction: e.target.value,
                      }))
                    }}
                  />
                </HStack>
                <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                  <XDatePicker
                    required={requirements.includes('tenth_details')}
                    maxDate={new Date()}
                    dateParser={(dateString) => {
                      return moment(dateString, 'DD/MM/YYYY').toDate()
                    }}
                    value={
                      formData.tenth_result_date
                        ? moment(formData.tenth_result_date as string, 'YYYY-MM-DD').toDate()
                        : null
                    }
                    width="100%"
                    clearable
                    placeholder="DD/MM/YYYY"
                    valueFormat={'DD/MM/YYYY'}
                    label={'Tenth Result Date'}
                    onChange={(value) => {
                      if (value) {
                        setFormData((prevData) => ({
                          ...prevData,
                          tenth_result_date: moment(value).format('YYYY-MM-DD'),
                        }))
                      } else {
                        setFormData((prevData) => ({
                          ...prevData,
                          tenth_result_date: '',
                        }))
                      }
                    }}
                    error={errors.tenth_result_date}
                  />
                </HStack>
              </HStack>
            </VStack>
          )}
          {tab === 'Twelfth' && fields.includes('twelfth_details') && (
            <VStack
              spacing="12px"
              style={{
                flex: '1 1 auto',
                paddingRight: '10px',
                height: leadStore.is_mobile_view ? 'auto' : '0',
                marginBottom: leadStore.is_mobile_view ? '50px' : '0px',
                overflowY: 'auto',
              }}
            >
              <HStack spacing="12px" style={{ flexWrap: 'wrap' }} alignItems="flex-start">
                <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                  <XNumberInput
                    required={requirements.includes('twelfth_details')}
                    type={'number'}
                    label={'Twelfth Year'}
                    error={errors.twelfth_year}
                    defaultValue={formData.twelfth_year}
                    onChange={(value) => {
                      setFormData((prevData) => ({
                        ...prevData,
                        twelfth_year: value,
                      }))
                    }}
                  />
                </HStack>
                <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                  <XSelect
                    required={requirements.includes('twelfth_details')}
                    searchable
                    label={'Twelfth Board'}
                    error={errors.twelfth_board}
                    value={formData.twelfth_board}
                    onInit={(callback) => {
                      axios
                        .post('/guest/select/lead-meta-options', {
                          entity_name: 'leads',
                          column_name: 'education_boards',
                          agency_id: agencyId,
                        })
                        .then((response) => {
                          callback(response.data)
                        })
                        .catch((error) => {
                          console.log(error)
                          callback([])
                        })
                    }}
                    onChange={(value) => {
                      if (value) {
                        setFormData((prevData) => ({
                          ...prevData,
                          twelfth_board: value,
                        }))
                      }
                    }}
                  />
                </HStack>
                <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                  <XTextInput
                    required={requirements.includes('twelfth_details')}
                    label={'Twelfth Percentage/CGPA'}
                    error={errors.twelfth_percentage}
                    value={formData.twelfth_percentage}
                    onChange={(e) => {
                      setFormData((prevData) => ({
                        ...prevData,
                        twelfth_percentage: e.target.value,
                      }))
                    }}
                  />
                </HStack>
              </HStack>
              <HStack spacing="12px" style={{ flexWrap: 'wrap' }} alignItems="flex-start">
                <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                  <XSelect
                    required={requirements.includes('twelfth_details')}
                    label={'Twelfth Stream'}
                    error={errors.twelfth_stream}
                    value={formData.twelfth_stream}
                    data={['Arts', 'Commerce', 'Medicine', 'Non-Medicine', 'Science', 'Others']}
                    onChange={(value) => {
                      if (value) {
                        setFormData((prevData) => ({
                          ...prevData,
                          twelfth_stream: value,
                        }))
                      } else {
                        setFormData((prevData) => ({
                          ...prevData,
                          twelfth_stream: '',
                        }))
                      }
                    }}
                  />
                </HStack>
                <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                  <XTextInput
                    required={requirements.includes('twelfth_details')}
                    label={'Twelfth School Name'}
                    error={errors.twelfth_school_name}
                    value={formData.twelfth_school_name}
                    onChange={(event) => {
                      setFormData((prevData) => ({
                        ...prevData,
                        twelfth_school_name: event.target.value,
                      }))
                    }}
                  />
                </HStack>
                <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                  <XTextInput
                    required={requirements.includes('twelfth_details')}
                    label={'Twelfth Medium of Instruction'}
                    error={errors.twelfth_medium_of_instruction}
                    value={formData.twelfth_medium_of_instruction}
                    onChange={(event) => {
                      setFormData((prevData) => ({
                        ...prevData,
                        twelfth_medium_of_instruction: event.target.value,
                      }))
                    }}
                  />
                </HStack>
              </HStack>
              <HStack spacing="12px" style={{ flexWrap: 'wrap' }} alignItems="flex-start">
                <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                  <XTextInput
                    required={requirements.includes('twelfth_details')}
                    label={'Twelfth English Marks'}
                    error={errors.twelfth_english_marks}
                    value={formData.twelfth_english_marks}
                    onChange={(event) => {
                      setFormData((prevData) => ({
                        ...prevData,
                        twelfth_english_marks: event.target.value,
                      }))
                    }}
                  />
                </HStack>
                <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                  <XDatePicker
                    required={requirements.includes('twelfth_details')}
                    maxDate={new Date()}
                    dateParser={(dateString) => {
                      return moment(dateString, 'DD/MM/YYYY').toDate()
                    }}
                    value={
                      formData.twelfth_result_date
                        ? moment(formData.twelfth_result_date as string, 'YYYY-MM-DD').toDate()
                        : null
                    }
                    width="100%"
                    clearable
                    placeholder="DD/MM/YYYY"
                    valueFormat={'DD/MM/YYYY'}
                    label={'Twelfth Result Date'}
                    onChange={(value) => {
                      if (value) {
                        setFormData((prevData) => ({
                          ...prevData,
                          twelfth_result_date: moment(value).format('YYYY-MM-DD'),
                        }))
                      } else {
                        setFormData((prevData) => ({
                          ...prevData,
                          twelfth_result_date: '',
                        }))
                      }
                    }}
                    error={errors.twelfth_result_date}
                  />
                </HStack>
              </HStack>
            </VStack>
          )}
          {tab === 'Bachelors' && fields.includes('bachelor_details') && (
            <VStack
              spacing="12px"
              style={{
                flex: '1 1 auto',
                paddingRight: '10px',
                height: leadStore.is_mobile_view ? 'auto' : '0',
                marginBottom: leadStore.is_mobile_view ? '50px' : '0px',
                overflowY: 'auto',
              }}
            >
              <VStack spacing="12px">
                <HStack spacing="12px" style={{ flexWrap: 'wrap' }} alignItems="flex-start">
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XNumberInput
                      required={requirements.includes('bachelor_details')}
                      type={'number'}
                      label={'Bachelor Year'}
                      error={errors.bachelor_one_year}
                      defaultValue={formData.bachelor_one_year}
                      onChange={(value) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          bachelor_one_year: value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XTextInput
                      required={requirements.includes('bachelor_details')}
                      label={'College/University'}
                      error={errors.bachelor_one_college}
                      value={formData.bachelor_one_college}
                      onChange={(event) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          bachelor_one_college: event.target.value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XTextInput
                      required={requirements.includes('bachelor_details')}
                      label={'Course Name'}
                      error={errors.bachelor_one_course}
                      value={formData.bachelor_one_course}
                      onChange={(event) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          bachelor_one_course: event.target.value,
                        }))
                      }}
                    />
                  </HStack>
                </HStack>
                <HStack spacing="12px" style={{ flexWrap: 'wrap' }} alignItems="flex-start">
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XTextInput
                      required={requirements.includes('bachelor_details')}
                      label={'Percentage/CGPA'}
                      error={errors.bachelor_one_percentage}
                      value={formData.bachelor_one_percentage}
                      onChange={(e) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          bachelor_one_percentage: e.target.value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XNumberInput
                      required={requirements.includes('bachelor_details')}
                      type={'number'}
                      label={'No of Reappears'}
                      error={errors.bachelor_one_reappears}
                      defaultValue={formData.bachelor_one_reappears}
                      onChange={(value) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          bachelor_one_reappears: value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XSelect
                      searchable
                      required={requirements.includes('bachelor_details')}
                      label={'Duration'}
                      error={errors.bachelor_one_duration}
                      value={formData.bachelor_one_duration}
                      data={['3 yr', '4 yr', '5 yr']}
                      onChange={(value) => {
                        if (value) {
                          setFormData((prevData) => ({
                            ...prevData,
                            bachelor_one_duration: value,
                          }))
                        } else {
                          setFormData((prevData) => ({
                            ...prevData,
                            bachelor_one_duration: '',
                          }))
                        }
                      }}
                    />
                  </HStack>
                  <div style={{ width: '100%' }}></div>
                </HStack>
                <HStack spacing="12px" style={{ flexWrap: 'wrap' }} alignItems="flex-start">
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XTextInput
                      required={requirements.includes('bachelor_details')}
                      label={'Medium of Instruction'}
                      error={errors.bachelor_one_medium_of_instruction}
                      value={formData.bachelor_one_medium_of_instruction}
                      onChange={(e) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          bachelor_one_medium_of_instruction: e.target.value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XDatePicker
                      required={requirements.includes('bachelor_details')}
                      maxDate={new Date()}
                      dateParser={(dateString) => {
                        return moment(dateString, 'DD/MM/YYYY').toDate()
                      }}
                      value={
                        formData.bachelor_one_result_date
                          ? moment(formData.bachelor_one_result_date as string, 'YYYY-MM-DD').toDate()
                          : null
                      }
                      clearable
                      placeholder="DD/MM/YYYY"
                      valueFormat={'DD/MM/YYYY'}
                      label={'Result Date'}
                      onChange={(value) => {
                        if (value) {
                          setFormData((prevData) => ({
                            ...prevData,
                            bachelor_one_result_date: moment(value).format('YYYY-MM-DD'),
                          }))
                        } else {
                          setFormData((prevData) => ({
                            ...prevData,
                            bachelor_one_result_date: '',
                          }))
                        }
                      }}
                      error={errors.bachelor_one_result_date}
                    />
                  </HStack>
                  <div style={{ width: '100%' }}></div>
                </HStack>
              </VStack>
              <HStack>
                <Divider variant={'dotted'} color={XelaColor.Gray10}></Divider>
              </HStack>
              <VStack spacing="12px">
                <HStack spacing="12px" style={{ flexWrap: 'wrap' }} alignItems="flex-start">
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XNumberInput
                      type={'number'}
                      label={'Bachelor Year'}
                      error={errors.bachelor_two_year}
                      defaultValue={formData.bachelor_two_year}
                      onChange={(value) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          bachelor_two_year: value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XTextInput
                      label={'College/University'}
                      error={errors.bachelor_two_college}
                      value={formData.bachelor_two_college}
                      onChange={(event) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          bachelor_two_college: event.target.value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XTextInput
                      label={'Course Name'}
                      error={errors.bachelor_two_course}
                      value={formData.bachelor_two_course}
                      onChange={(event) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          bachelor_two_course: event.target.value,
                        }))
                      }}
                    />
                  </HStack>
                </HStack>
                <HStack spacing="12px" style={{ flexWrap: 'wrap' }} alignItems="flex-start">
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XTextInput
                      label={'Percentage/CGPA'}
                      error={errors.bachelor_two_percentage}
                      value={formData.bachelor_two_percentage}
                      onChange={(e) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          bachelor_two_percentage: e.target.value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XNumberInput
                      type={'number'}
                      label={'No of Reappears'}
                      error={errors.bachelor_two_reappears}
                      defaultValue={formData.bachelor_two_reappears}
                      onChange={(value) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          bachelor_two_reappears: value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XSelect
                      required={requirements.includes('master_details')}
                      label={'Duration'}
                      error={errors.bachelor_two_duration}
                      value={formData.bachelor_two_duration}
                      data={['3 yr', '4 yr', '5 yr']}
                      onChange={(value) => {
                        if (value) {
                          setFormData((prevData) => ({
                            ...prevData,
                            bachelor_two_duration: value,
                          }))
                        } else {
                          setFormData((prevData) => ({
                            ...prevData,
                            bachelor_two_duration: '',
                          }))
                        }
                      }}
                    />
                  </HStack>
                  <div style={{ width: '100%' }}></div>
                </HStack>
                <HStack spacing="12px" style={{ flexWrap: 'wrap' }} alignItems="flex-start">
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XTextInput
                      label={'Medium of Instruction'}
                      error={errors.bachelor_two_medium_of_instruction}
                      value={formData.bachelor_two_medium_of_instruction}
                      onChange={(e) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          bachelor_two_medium_of_instruction: e.target.value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XDatePicker
                      maxDate={new Date()}
                      dateParser={(dateString) => {
                        return moment(dateString, 'DD/MM/YYYY').toDate()
                      }}
                      value={
                        formData.bachelor_two_result_date
                          ? moment(formData.bachelor_two_result_date as string, 'YYYY-MM-DD').toDate()
                          : null
                      }
                      clearable
                      placeholder="DD/MM/YYYY"
                      valueFormat={'DD/MM/YYYY'}
                      label={'Result Date'}
                      onChange={(value) => {
                        if (value) {
                          setFormData((prevData) => ({
                            ...prevData,
                            bachelor_two_result_date: moment(value).format('YYYY-MM-DD'),
                          }))
                        } else {
                          setFormData((prevData) => ({
                            ...prevData,
                            bachelor_two_result_date: '',
                          }))
                        }
                      }}
                      error={errors.bachelor_two_result_date}
                    />
                  </HStack>
                  <div style={{ width: '100%' }}></div>
                </HStack>
              </VStack>
            </VStack>
          )}
          {tab === 'Masters' && fields.includes('master_details') && (
            <VStack
              spacing="12px"
              style={{
                flex: '1 1 auto',
                paddingRight: '10px',
                height: leadStore.is_mobile_view ? 'auto' : '0',
                marginBottom: leadStore.is_mobile_view ? '50px' : '0px',
                overflowY: 'auto',
              }}
            >
              <VStack spacing="12px">
                <HStack spacing="12px" style={{ flexWrap: 'wrap' }} alignItems="flex-start">
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XNumberInput
                      required={requirements.includes('master_details')}
                      type={'number'}
                      label={'Master Year'}
                      error={errors.master_one_year}
                      defaultValue={formData.master_one_year}
                      onChange={(value) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          master_one_year: value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XTextInput
                      required={requirements.includes('master_details')}
                      label={'College/University'}
                      error={errors.master_one_college}
                      value={formData.master_one_college}
                      onChange={(event) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          master_one_college: event.target.value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XTextInput
                      required={requirements.includes('master_details')}
                      label={'Course Name'}
                      error={errors.master_one_course}
                      value={formData.master_one_course}
                      onChange={(event) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          master_one_course: event.target.value,
                        }))
                      }}
                    />
                  </HStack>
                </HStack>
                <HStack spacing="12px" style={{ flexWrap: 'wrap' }} alignItems="flex-start">
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XTextInput
                      required={requirements.includes('master_details')}
                      label={'Percentage/CGPA'}
                      error={errors.master_one_percentage}
                      value={formData.master_one_percentage}
                      onChange={(e) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          master_one_percentage: e.target.value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XNumberInput
                      required={requirements.includes('master_details')}
                      type={'number'}
                      label={'No of Reappears'}
                      error={errors.master_one_reappears}
                      defaultValue={formData.master_one_reappears}
                      onChange={(value) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          master_one_reappears: value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XSelect
                      required={requirements.includes('master_details')}
                      label={'Duration'}
                      error={errors.master_one_duration}
                      value={formData.master_one_duration}
                      data={['1 yr', '2 yr', '3 yr']}
                      onChange={(value) => {
                        if (value) {
                          setFormData((prevData) => ({
                            ...prevData,
                            master_one_duration: value,
                          }))
                        } else {
                          setFormData((prevData) => ({
                            ...prevData,
                            master_one_duration: '',
                          }))
                        }
                      }}
                    />
                  </HStack>
                  <div style={{ width: '100%' }}></div>
                </HStack>
                <HStack spacing="12px" style={{ flexWrap: 'wrap' }} alignItems="flex-start">
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XTextInput
                      required={requirements.includes('master_details')}
                      label={'Medium of Instruction'}
                      error={errors.master_one_medium_of_instruction}
                      value={formData.master_one_medium_of_instruction}
                      onChange={(e) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          master_one_medium_of_instruction: e.target.value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XDatePicker
                      required={requirements.includes('master_details')}
                      maxDate={new Date()}
                      dateParser={(dateString) => {
                        return moment(dateString, 'DD/MM/YYYY').toDate()
                      }}
                      value={
                        formData.master_one_result_date
                          ? moment(formData.master_one_result_date as string, 'YYYY-MM-DD').toDate()
                          : null
                      }
                      clearable
                      placeholder="DD/MM/YYYY"
                      valueFormat={'DD/MM/YYYY'}
                      label={'Result Date'}
                      onChange={(value) => {
                        if (value) {
                          setFormData((prevData) => ({
                            ...prevData,
                            master_one_result_date: moment(value).format('YYYY-MM-DD'),
                          }))
                        } else {
                          setFormData((prevData) => ({
                            ...prevData,
                            master_one_result_date: '',
                          }))
                        }
                      }}
                      error={errors.master_one_result_date}
                    />
                  </HStack>
                  <div style={{ width: '100%' }}></div>
                </HStack>
              </VStack>
              <HStack>
                <Divider variant={'dotted'} color={XelaColor.Gray10}></Divider>
              </HStack>
              <VStack spacing="12px">
                <HStack spacing="12px" style={{ flexWrap: 'wrap' }} alignItems="flex-start">
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XNumberInput
                      type={'number'}
                      label={'Master Year'}
                      error={errors.master_two_year}
                      defaultValue={formData.master_two_year}
                      onChange={(value) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          master_two_year: value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XTextInput
                      label={'College/University'}
                      error={errors.master_two_college}
                      value={formData.master_two_college}
                      onChange={(event) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          master_two_college: event.target.value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XTextInput
                      label={'Course Name'}
                      error={errors.master_two_course}
                      value={formData.master_two_course}
                      onChange={(event) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          master_two_course: event.target.value,
                        }))
                      }}
                    />
                  </HStack>
                </HStack>
                <HStack spacing="12px" style={{ flexWrap: 'wrap' }} alignItems="flex-start">
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XTextInput
                      label={'Percentage/CGPA'}
                      error={errors.master_two_percentage}
                      value={formData.master_two_percentage}
                      onChange={(e) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          master_two_percentage: e.target.value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XNumberInput
                      type={'number'}
                      label={'No of Reappears'}
                      error={errors.master_two_reappears}
                      defaultValue={formData.master_two_reappears}
                      onChange={(value) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          master_two_reappears: value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XSelect
                      required={requirements.includes('master_details')}
                      label={'Duration'}
                      error={errors.master_two_duration}
                      value={formData.master_two_duration}
                      data={['1 yr', '2 yr', '3 yr']}
                      onChange={(value) => {
                        if (value) {
                          setFormData((prevData) => ({
                            ...prevData,
                            master_two_duration: value,
                          }))
                        } else {
                          setFormData((prevData) => ({
                            ...prevData,
                            master_two_duration: '',
                          }))
                        }
                      }}
                    />
                  </HStack>
                  <div style={{ width: '100%' }}></div>
                </HStack>
                <HStack spacing="12px" style={{ flexWrap: 'wrap' }} alignItems="flex-start">
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XTextInput
                      label={'Medium of Instruction'}
                      error={errors.master_two_medium_of_instruction}
                      value={formData.master_two_medium_of_instruction}
                      onChange={(e) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          master_two_medium_of_instruction: e.target.value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XDatePicker
                      maxDate={new Date()}
                      dateParser={(dateString) => {
                        return moment(dateString, 'DD/MM/YYYY').toDate()
                      }}
                      value={
                        formData.master_two_result_date
                          ? moment(formData.master_two_result_date as string, 'YYYY-MM-DD').toDate()
                          : null
                      }
                      clearable
                      placeholder="DD/MM/YYYY"
                      valueFormat={'DD/MM/YYYY'}
                      label={'Result Date'}
                      onChange={(value) => {
                        if (value) {
                          setFormData((prevData) => ({
                            ...prevData,
                            master_two_result_date: moment(value).format('YYYY-MM-DD'),
                          }))
                        } else {
                          setFormData((prevData) => ({
                            ...prevData,
                            master_two_result_date: '',
                          }))
                        }
                      }}
                      error={errors.master_two_result_date}
                    />
                  </HStack>
                  <div style={{ width: '100%' }}></div>
                </HStack>
              </VStack>
            </VStack>
          )}
          {tab === 'Diplomas' && fields.includes('diploma_details') && (
            <VStack
              spacing="12px"
              style={{
                flex: '1 1 auto',
                paddingRight: '10px',
                height: leadStore.is_mobile_view ? 'auto' : '0',
                marginBottom: leadStore.is_mobile_view ? '50px' : '0px',
                overflowY: 'auto',
              }}
            >
              <VStack spacing="12px">
                <HStack spacing="12px" style={{ flexWrap: 'wrap' }} alignItems="flex-start">
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XNumberInput
                      required={requirements.includes('diploma_details')}
                      type={'number'}
                      label={'Diploma Year'}
                      error={errors.diploma_one_year}
                      defaultValue={formData.diploma_one_year}
                      onChange={(value) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          diploma_one_year: value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XTextInput
                      required={requirements.includes('diploma_details')}
                      label={'College/University'}
                      error={errors.diploma_one_college}
                      value={formData.diploma_one_college}
                      onChange={(event) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          diploma_one_college: event.target.value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XTextInput
                      required={requirements.includes('diploma_details')}
                      label={'Course Name'}
                      error={errors.diploma_one_course}
                      value={formData.diploma_one_course}
                      onChange={(event) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          diploma_one_course: event.target.value,
                        }))
                      }}
                    />
                  </HStack>
                </HStack>
                <HStack spacing="12px" style={{ flexWrap: 'wrap' }} alignItems="flex-start">
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XTextInput
                      required={requirements.includes('diploma_details')}
                      label={'Percentage/CGPA'}
                      error={errors.diploma_one_percentage}
                      value={formData.diploma_one_percentage}
                      onChange={(e) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          diploma_one_percentage: e.target.value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XNumberInput
                      required={requirements.includes('diploma_details')}
                      type={'number'}
                      label={'No of Reappears'}
                      error={errors.diploma_one_reappears}
                      defaultValue={formData.diploma_one_reappears}
                      onChange={(value) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          diploma_one_reappears: value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XSelect
                      required={requirements.includes('diploma_details')}
                      label={'Duration'}
                      error={errors.diploma_one_duration}
                      value={formData.diploma_one_duration}
                      data={['1 yr', '2 yr', '3 yr']}
                      onChange={(value) => {
                        if (value) {
                          setFormData((prevData) => ({
                            ...prevData,
                            diploma_one_duration: value,
                          }))
                        } else {
                          setFormData((prevData) => ({
                            ...prevData,
                            diploma_one_duration: '',
                          }))
                        }
                      }}
                    />
                  </HStack>
                </HStack>
                <HStack spacing="12px" style={{ flexWrap: 'wrap' }} alignItems="flex-start">
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XSelect
                      label={'Level'}
                      error={errors.diploma_one_level}
                      value={formData.diploma_one_level}
                      data={['12th', 'UG', 'PG']}
                      onChange={(value) => {
                        if (value) {
                          setFormData((prevData) => ({
                            ...prevData,
                            diploma_one_level: value,
                          }))
                        } else {
                          setFormData((prevData) => ({
                            ...prevData,
                            diploma_one_level: '',
                          }))
                        }
                      }}
                    />
                  </HStack>
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XTextInput
                      label={'Medium of Instruction'}
                      error={errors.diploma_one_medium_of_instruction}
                      value={formData.diploma_one_medium_of_instruction}
                      onChange={(e) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          diploma_one_medium_of_instruction: e.target.value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XDatePicker
                      required={requirements.includes('diploma_details')}
                      maxDate={new Date()}
                      dateParser={(dateString) => {
                        return moment(dateString, 'DD/MM/YYYY').toDate()
                      }}
                      value={
                        formData.diploma_one_result_date
                          ? moment(formData.diploma_one_result_date as string, 'YYYY-MM-DD').toDate()
                          : null
                      }
                      clearable
                      placeholder="DD/MM/YYYY"
                      valueFormat={'DD/MM/YYYY'}
                      label={'Result Date'}
                      onChange={(value) => {
                        if (value) {
                          setFormData((prevData) => ({
                            ...prevData,
                            diploma_one_result_date: moment(value).format('YYYY-MM-DD'),
                          }))
                        } else {
                          setFormData((prevData) => ({
                            ...prevData,
                            diploma_one_result_date: '',
                          }))
                        }
                      }}
                      error={errors.diploma_one_result_date}
                    />
                  </HStack>
                </HStack>
              </VStack>
              <HStack>
                <Divider variant={'dotted'} color={XelaColor.Gray10}></Divider>
              </HStack>
              <VStack spacing="12px">
                <HStack spacing="12px" style={{ flexWrap: 'wrap' }} alignItems="flex-start">
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XNumberInput
                      type={'number'}
                      label={'Diploma Year'}
                      error={errors.diploma_two_year}
                      defaultValue={formData.diploma_two_year}
                      onChange={(value) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          diploma_two_year: value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XTextInput
                      label={'College/University'}
                      error={errors.diploma_two_college}
                      value={formData.diploma_two_college}
                      onChange={(event) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          diploma_two_college: event.target.value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XTextInput
                      label={'Course Name'}
                      error={errors.diploma_two_course}
                      value={formData.diploma_two_course}
                      onChange={(event) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          diploma_two_course: event.target.value,
                        }))
                      }}
                    />
                  </HStack>
                </HStack>
                <HStack spacing="12px" style={{ flexWrap: 'wrap' }} alignItems="flex-start">
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XTextInput
                      label={'Percentage/CGPA'}
                      error={errors.diploma_two_percentage}
                      value={formData.diploma_two_percentage}
                      onChange={(e) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          diploma_two_percentage: e.target.value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XNumberInput
                      type={'number'}
                      label={'No of Reappears'}
                      error={errors.diploma_two_reappears}
                      defaultValue={formData.diploma_two_reappears}
                      onChange={(value) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          diploma_two_reappears: value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XSelect
                      required={requirements.includes('diploma_details')}
                      label={'Duration'}
                      error={errors.diploma_two_duration}
                      value={formData.diploma_two_duration}
                      data={['1 yr', '2 yr', '3 yr']}
                      onChange={(value) => {
                        if (value) {
                          setFormData((prevData) => ({
                            ...prevData,
                            diploma_two_duration: value,
                          }))
                        } else {
                          setFormData((prevData) => ({
                            ...prevData,
                            diploma_two_duration: '',
                          }))
                        }
                      }}
                    />
                  </HStack>
                  <div style={{ width: '100%' }}></div>
                </HStack>
                <HStack spacing="12px" style={{ flexWrap: 'wrap' }} alignItems="flex-start">
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XSelect
                      label={'Level'}
                      error={errors.diploma_two_level}
                      value={formData.diploma_two_level}
                      data={['12th', 'UG', 'PG']}
                      onChange={(value) => {
                        if (value) {
                          setFormData((prevData) => ({
                            ...prevData,
                            diploma_two_level: value,
                          }))
                        } else {
                          setFormData((prevData) => ({
                            ...prevData,
                            diploma_two_level: '',
                          }))
                        }
                      }}
                    />
                  </HStack>
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XTextInput
                      label={'Medium of Instruction'}
                      error={errors.diploma_two_medium_of_instruction}
                      value={formData.diploma_two_medium_of_instruction}
                      onChange={(e) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          diploma_two_medium_of_instruction: e.target.value,
                        }))
                      }}
                    />
                  </HStack>
                  <HStack width={leadStore.is_mobile_view ? '100%' : '270px'}>
                    <XDatePicker
                      maxDate={new Date()}
                      dateParser={(dateString) => {
                        return moment(dateString, 'DD/MM/YYYY').toDate()
                      }}
                      value={
                        formData.diploma_two_result_date
                          ? moment(formData.diploma_two_result_date as string, 'YYYY-MM-DD').toDate()
                          : null
                      }
                      clearable
                      placeholder="DD/MM/YYYY"
                      valueFormat={'DD/MM/YYYY'}
                      label={'Result Date'}
                      onChange={(value) => {
                        if (value) {
                          setFormData((prevData) => ({
                            ...prevData,
                            diploma_two_result_date: moment(value).format('YYYY-MM-DD'),
                          }))
                        } else {
                          setFormData((prevData) => ({
                            ...prevData,
                            diploma_two_result_date: '',
                          }))
                        }
                      }}
                      error={errors.diploma_two_result_date}
                    />
                  </HStack>
                  <div style={{ width: '100%' }}></div>
                </HStack>
              </VStack>
            </VStack>
          )}
          {tab === 'Others' && fields.includes('other_educations') && (
            <VStack
              spacing="12px"
              style={{
                flex: '1 1 auto',
                paddingRight: '10px',
                height: leadStore.is_mobile_view ? 'auto' : '0',
                marginBottom: leadStore.is_mobile_view ? '50px' : '0px',
                overflowY: 'auto',
              }}
            >
              <VStack spacing="12px">
                <HStack spacing="12px" style={{ flexWrap: 'wrap' }} alignItems="flex-start">
                  <HStack width={leadStore.is_mobile_view ? '100%' : '4200px'}>
                    <XTextarea
                      required={requirements.includes('other_educations')}
                      minRows={4}
                      label={'Other Educations'}
                      error={errors.other_educations}
                      value={formData.other_educations}
                      onChange={(event) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          other_educations: event.target.value,
                        }))
                      }}
                    />
                  </HStack>
                </HStack>
              </VStack>
            </VStack>
          )}
          {!leadStore.is_mobile_view && (
            <>
              <HStack>
                <Divider variant={'dotted'}></Divider>
              </HStack>
              <HStack spacing={'16px'} justifyContent="flex-end">
                <Button
                  label={'Back'}
                  variant="secondary"
                  onClick={() => {
                    dispatch(updateCurrentStep(leadStore.current_step - 1))
                  }}
                ></Button>
                <Button
                  label={leadStore.current_step === leadStore.total_step - 1 ? 'Save' : 'Save & Next'}
                  onClick={handleSubmit}
                ></Button>
              </HStack>
            </>
          )}
        </VStack>
      </div>
    </>
  )
}

export default LeadFormEducationDetail
